export type AuthMode = 'web' | 'app'

export interface AuthConfig {
  /**
   * 登录模式
   * - web: 默认短期会话（支持“记住我”）
   * - app: 长期会话（配合刷新令牌保持活跃）
   */
  mode: AuthMode
  /**
   * Web 默认是否记住登录
   */
  webDefaultRememberMe: boolean
  /**
   * 访问令牌刷新阈值（秒）
   */
  refreshThresholdSeconds: number
}

const authConfig: AuthConfig = {
  mode: 'web',
  webDefaultRememberMe: false,
  refreshThresholdSeconds: 120
}

export default authConfig
